import GetIncomeMokuTip from './GetIncomeMokuTip'

export default GetIncomeMokuTip
